var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="columnPicker--category">\n  <div class="columnPicker--category-title">\n    <strong>'+
((__t=( category ))==null?'':_.escape(__t))+
'</strong>\n  </div>\n  <a href="javascript:;" name="'+
((__t=( categoryId ))==null?'':_.escape(__t))+
'" class="select-all">Select all</a>\n  |\n  <a href="javascript:;" name="'+
((__t=( categoryId ))==null?'':_.escape(__t))+
'" class="deselect-all">Deselect all</a>\n  <div id="'+
((__t=( categoryId ))==null?'':_.escape(__t))+
'" data-mount="category" class="force_wrap"></div>\n</div>\n';
}
return __p;
};
